import React from "react";

const AvatarCircleIcon = ({
  size = 24,
  backgroundColor = "#D2C3B1",
  color = "#3C2212",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect
        width="24"
        height="24"
        rx="12"
        fill={backgroundColor}
      />

      <path
        d="M13.125 13.125C15.3984 13.125 17.25 14.9766 17.25 17.25C17.25 17.6719 16.8984 18 16.5 18H7.5C7.07812 18 6.75 17.6719 6.75 17.25C6.75 14.9766 8.57812 13.125 10.875 13.125H13.125ZM7.875 16.875H16.1016C15.9141 15.3984 14.6484 14.25 13.125 14.25H10.875C9.32812 14.25 8.0625 15.3984 7.875 16.875ZM12 12C10.3359 12 9 10.6641 9 9C9 7.35938 10.3359 6 12 6C13.6406 6 15 7.35938 15 9C15 10.6641 13.6406 12 12 12ZM12 7.125C10.9453 7.125 10.125 7.96875 10.125 9C10.125 10.0547 10.9453 10.875 12 10.875C13.0312 10.875 13.875 10.0547 13.875 9C13.875 7.96875 13.0312 7.125 12 7.125Z"
        fill={color}
      />
    </svg>
  );
};

export default AvatarCircleIcon;